import { type ReactNode } from "react";
import { useSidebar } from "../context/SidebarProvider";

interface CustomSidebarButtonProps {
  label?: string;
  icon?: ReactNode;
  sidebarContent: ReactNode;
  sidebarHeader?: ReactNode;
  side?: "left" | "right"; // New prop
  padding?: string;
  rounded?: string;
  bgColor?: string;
  hoverColor?: string;
  textColor?: string;
  textButtonClassName?: string;
  textButton?: boolean;
  button?: ReactNode;
}

export default function CustomSidebarButton({
  sidebarContent,
  sidebarHeader,
  side = "left",
  button = null,
}: CustomSidebarButtonProps) {
  const { openSidebar } = useSidebar();

  const handleOpen = () => {
    openSidebar(sidebarContent, sidebarHeader, side);
  };


  return <div className="text-gray-800 dark:text-gray-300  eng text-2xl flex" onClick={handleOpen}>{button}</div>;

}